import React, { useEffect, useState, useContext } from 'react';
import api from '../../services/api';
import * as S from './styles';
import * as C from './CadastroUsuarioModal.styles';
import MaskedInput from 'react-text-mask';
import bcrypt from 'bcryptjs';
import Cookies from 'js-cookie';

import { Context } from '../../services/contexts/StateContext';
import { PesquisaPadrao } from '../../componentes/Pesquisas/PesquisaPadrao';
import { Functions, FunctModal } from '../../componentes/Functions';

export function ModalUsuario(props) {
    const { state, dispatch } = useContext(Context);
    const { parametroInit, listaPesquisa } = state.parametros;
    const { usuario, logado } = state.cliente;
    const { id_Usuario } = usuario;
    const {
        detalhesModal,
        disabled, detalhesLista, editModal, atualizarModal } = parametroInit;
    // const listaFranquia = ListaFranquia();
    const { PesqCPFUsuario, Limpar_Modal } = Functions();
    const { FecharModal } = FunctModal();


    //---------------------------------------------
    const setUsuario = (key, value) => {
        dispatch({
            type: 'set_usuario',
            payload: { ...usuario, [key]: value }
        });
    };
    //--------------------------Atualizar----------
    function Atualizar() {
        if (detalhesModal) {
            dispatch({
                type: 'SET_parametroInit',
                payload: {
                    ...parametroInit,
                    editModal: true,
                    disabled: false,
                    detalhesModal: false
                }
            });
        };

    };

    //----------Add Usuario----------
    async function addUsuario(e) {
        if (!parametroInit.editModal) {
            e.preventDefault(); // prevenir que o formulario não seja enviado antes de preenchido

            if (!usuario.senha || usuario.senha.length < 8) {
                alert('A senha deve ter ao menos 8 caracteres.');
                return;
            }
            if (usuario.senha !== usuario.confirmeSenha) {
                alert('Senha não Confirmada!')
                return;
            }
            await api.post('/usuario/add', { //post - Criar
                userCadastro: logado.idLogado,
                nome: usuario.nome,
                cpf: listaPesquisa.nomeItem,
                email: usuario.email,
                senha: usuario.senha,
            }, {
                headers: { Authorization: `Bearer ${Cookies.get('token')}` }
            }).then(res => {
                alert('Usuario Cadastrado!');
                Limpar_Modal();
                FecharModal();
            }).catch(erro => alert(erro))
        }
        //-------atualizar------
        if (parametroInit.editModal) {
            if (usuario.senha && (usuario.senha.length < 8 || usuario.senha !== usuario.confirmeSenha)) {
                alert('A senha deve ter ao menos 8 caracteres e ser igual à confirmação.');
                return;
            }
            const crypSenha = usuario.senha? await bcrypt.hash(usuario.senha, 10) : null;

            const campos = {
                nome: usuario.nome,
                email: usuario.email,
                senha: crypSenha,
                data_modificado: Date.now(),
            };

            // Remover campos nulos
            Object.keys(campos).forEach(key => {
                if (campos[key] === null || campos[key] === undefined || campos[key] === "") {
                    delete campos[key];
                }
            });

            await api.put(`/usuario/atualizar/${id_Usuario}`, campos, {
                headers: { Authorization: `Bearer ${Cookies.get('token')}` }
            }).then(res => {
                alert('Usuario Atualizado!');
                Limpar_Modal();
                FecharModal();
            }).catch(erro => alert(erro));
        }
    };
    //----Retirando Pontos do cpf------------------
    const [cpfFormat, setcpfFormat] = useState('');

    useEffect(() => {
        let value = cpfFormat;
        if (cpfFormat) {
            let rr = value.replace(/\D/g, ''); //.replace(/\D/gim, '')
            setUsuario('cpf', rr)
        }
    }, [cpfFormat])
    // ----------------------

    useEffect(() => {
        if (listaPesquisa.nomeItem?.length == 11) {
            PesqCPFUsuario(listaPesquisa.nomeItem)
        };

        if (listaPesquisa.nomeItem?.length <= 11) {
            dispatch({
                type: 'SET_parametroInit',
                payload: { ...parametroInit, botaoCPF: false }
            });
        };
    }, [listaPesquisa.nomeItem]);
    // ---------------------------

    // #########################################################
    const novoUsuario = !detalhesLista && !editModal && !atualizarModal;
    const titulo = detalhesLista ? 'Meus dados' : novoUsuario ? 'Novo usuário' : 'Editar dados';
    const cpfValor = novoUsuario ? (listaPesquisa.nomeItem || '') : (usuario.cpf || '');

    return (
        <C.Overlay onMouseDown={e => {
            if (e.target === e.currentTarget) FecharModal();
        }}>
            <C.Card role="dialog" aria-modal="true" aria-labelledby="usuario-title">
                <C.CloseButton type="button" aria-label="Fechar" onClick={() => FecharModal()}>
                    ×
                </C.CloseButton>

                <C.Eyebrow>Usuário</C.Eyebrow>
                <h2 id="usuario-title">{titulo}</h2>
                <C.Description>
                    {detalhesLista
                        ? 'Confira seus dados. Clique em Atualizar para editar.'
                        : 'Deixe a senha em branco para mantê-la.'}
                </C.Description>

                <C.Fields>
                    <label>
                        CPF
                        <MaskedInput
                            disabled={!novoUsuario}
                            autoComplete="off"
                            mask={[/\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '-', /\d/, /\d/]}
                            value={cpfValor}
                            onChange={e => {
                                if (novoUsuario) {
                                    dispatch({
                                        type: 'set_ListaPesquisa',
                                        payload: { ...listaPesquisa, nomeItem: e.target.value.replace(/\D/g, '') }
                                    });
                                }
                            }}
                            guide={false}
                            placeholder="000.000.000-00"
                        />
                    </label>

                    <label>
                        Nome completo
                        <input
                            disabled={disabled}
                            maxLength={120}
                            value={usuario.nome || ''}
                            onChange={e => setUsuario('nome', e.target.value)}
                        />
                    </label>

                    <label>
                        E-mail
                        <input
                            disabled={disabled}
                            maxLength={160}
                            type="email"
                            value={usuario.email || ''}
                            onChange={e => setUsuario('email', e.target.value)}
                        />
                    </label>

                    <C.PasswordFields>
                        <label>
                            Senha
                            <input
                                disabled={disabled}
                                autoComplete="new-password"
                                type="password"
                                value={usuario.senha || ''}
                                onChange={e => setUsuario('senha', e.target.value)}
                            />
                        </label>
                        <label>
                            Confirmar senha
                            <input
                                disabled={disabled}
                                autoComplete="new-password"
                                type="password"
                                value={usuario.confirmeSenha || ''}
                                onChange={e => setUsuario('confirmeSenha', e.target.value)}
                            />
                        </label>
                    </C.PasswordFields>
                </C.Fields>

                {detalhesModal ? (
                    <C.SubmitButton type="button" onClick={Atualizar}>Atualizar</C.SubmitButton>
                ) : (
                    <C.SubmitButton type="button" onClick={addUsuario}>Salvar</C.SubmitButton>
                )}
            </C.Card>
        </C.Overlay>
    );
}
